import { VueModule } from '@Foundation/utilities';
import LeadIframe from './code/Scripts/components/lead-iframe-popup.vue';

export default VueModule({
    components: {
        LeadIframe
    }
})